// Replaceable preview configuration. Business type belongs to the establishment.
export function loadPreviewConfiguration(url = new URL(location.href)) {
  const valid = ['restaurant', 'cafe', 'friseur', 'retail', 'kiosk'];
  const business = valid.includes(url.searchParams.get('biz')) ? url.searchParams.get('biz') : 'restaurant';
  return Object.freeze({business, dayOne: url.searchParams.get('day1') !== '0', theme: url.searchParams.get('theme')});
}
export function configurePreview() {
  const config = loadPreviewConfiguration();
  window.ZalsoPreviewConfiguration = config;
  window.__BIZ = config.business;
  window.__LOCK = 1;
  window.DAY1 = config.dayOne;
  window.__MODE = config.business === 'friseur' ? 'friseur' : ['retail','kiosk'].includes(config.business) ? 'retail' : 'gastro';
  window.__EMBED = false;
  document.documentElement.setAttribute('data-noframe', '1');
  const theme = config.theme || localStorage.getItem('zalso-theme') || 'light';
  document.documentElement.setAttribute('data-theme', theme === 'dark' ? 'dark' : 'light');
  document.title += ' · SIMULATION';
  return config;
}
